import { Timer, TriangleAlert } from 'lucide-react';

const INPUT_CLS = `flex w-full rounded-xl border px-3 py-1.5 placeholder:text-white/20 transition-all hover:border-white/10 focus:outline-none focus:ring-1 focus:ring-[var(--brand-500)]/30 focus:border-[var(--brand-500)]/30 h-7 bg-[#111111] text-white text-xs mt-1`;
const SELECT_CLS = `flex w-full rounded-xl border border-white/[0.06] px-3 py-1.5 h-7 bg-[#111111] text-white text-xs mt-1 focus:outline-none focus:ring-1 focus:ring-[var(--brand-500)]/30`;

/**
 * Nó "Gerar pagamento SPEI" (México, XPag). O valor já é em MXN: sem conversão
 * nem menu de moeda. O comprador recebe a CLABE no chat, em espanhol; a mensagem
 * é a do SPEI (não há texto nem botão para configurar).
 */
export default function SpeiPaymentNode({ id, data }) {
    const planName = data?.paymentPlanName || '';
    const planDuration = data?.paymentPlanDuration || 'mensal';
    const amount = data?.paymentAmount ?? '';
    const pendingTimeoutMinutes = data?.pendingTimeoutMinutes ?? 30;

    const change = (patch) => data?.onChangePayment?.(id, patch);

    return (
        <div className="mt-2 space-y-2 pl-2">
            {(!planName || !parseFloat(amount)) && (
                <div className="flex items-center gap-1.5 rounded-md bg-red-500/10 border border-red-500/30 px-2 py-1.5 text-[10px] text-red-400">
                    <TriangleAlert size={11} aria-hidden="true" />
                    <span>{!planName ? 'Nome do plano obrigatório.' : 'Valor deve ser maior que zero.'}</span>
                </div>
            )}

            <div>
                <label className="text-[9px] text-white/40">Nome do Plano</label>
                <input type="text" className={`${INPUT_CLS} ${!planName ? 'border-red-500/40' : 'border-white/[0.06]'}`}
                    placeholder="Ex: Acceso Premium" value={planName}
                    onChange={(e) => change({ paymentPlanName: e.target.value })} />
            </div>

            <div>
                <label className="text-[9px] text-white/40">Valor (MXN)</label>
                <input type="number" min="0" step="0.01"
                    className={`${INPUT_CLS} [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none ${!parseFloat(amount) ? 'border-red-500/40' : 'border-white/[0.06]'}`}
                    placeholder="0.00" value={amount}
                    onChange={(e) => change({ paymentAmount: e.target.value })} />
                <p className="text-[8px] text-white/30 mt-0.5">Cobrado em pesos mexicanos pelo SPEI da XPag, sem conversão.</p>
            </div>

            <div>
                <label className="text-[9px] text-white/40">Duração do Acesso</label>
                <select className={SELECT_CLS} value={planDuration}
                    onChange={(e) => change({ paymentPlanDuration: e.target.value })}>
                    <option value="mensal">Mensal (30 dias)</option>
                    <option value="semanal">Semanal</option>
                    <option value="quinzenal">Quinzenal</option>
                    <option value="trimestral">Trimestral</option>
                    <option value="semestral">Semestral</option>
                    <option value="anual">Anual</option>
                    <option value="vitalicio">Vitalício</option>
                </select>
            </div>

            <div className="border-t border-white/[0.06] pt-2 mt-2">
                <div className="flex items-center gap-1.5 mb-1.5">
                    <Timer size={10} className="text-white/40" aria-hidden="true" />
                    <label className="text-[9px] text-white/40">Tempo para "Não Pago"</label>
                </div>
                <div className="flex items-center gap-1.5">
                    <input type="number" min="1" max="1440"
                        className="w-16 h-6 bg-[#111111] border border-white/[0.06] text-white text-[10px] rounded px-1.5 text-center focus:outline-none focus:ring-1 focus:ring-[var(--brand-500)]/30"
                        value={pendingTimeoutMinutes}
                        onChange={(e) => change({ pendingTimeoutMinutes: e.target.value })} />
                    <span className="text-[9px] text-white/40">minutos</span>
                </div>
                <p className="text-[8px] text-white/30 mt-1">Se não pagar, segue pelo caminho "NÃO PAGO" após esse tempo</p>
            </div>

            <div className="flex justify-between text-[9px] font-semibold px-1 pt-2 pb-1 border-t border-white/[0.06] mt-2">
                <span className="text-red-400">❌ Não Pago</span>
                <span className="text-emerald-400">✅ Pago</span>
            </div>
        </div>
    );
}
